import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SettingsPage } from "@/features/settings/settings-page";

export const Route = createFileRoute("/_authenticated/$store/settings/")({
  validateSearch: z.object({
    section: z.enum(["store", "offers", "messaging", "appointments", "team", "account"]).optional().catch(undefined),
  }),
  head: () => ({ meta: [{ title: "Settings · Rogue AI" }] }),
  component: SettingsPage,
});
